import type { IconSvgObject } from './types';

const CirclePoundSterlingIcon: IconSvgObject = [
  ["path", { d: "M14.9909 9.73155C14.9479 9.14951 14.6199 7.7393 13.3593 7.21828C11.7836 6.56699 9.70875 7.38656 9.51462 9.4976C9.42353 10.4881 9.93434 11.5267 10.6766 12.0398C11.3586 12.5112 12.3935 12.4874 13.3593 12.4874H8M11.2374 12.4874C11.0558 13.1794 10.0588 15.1686 8.47006 15.9987H14.2516C14.4753 15.9987 15.1064 16.0534 16 15.4513", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CirclePoundSterlingIcon;
